import { PropsWithChildren } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface RadioGroupIconProps extends PropsWithChildren {
  className?: string;
}

/**
 * A decorative icon shown before the label. Wraps its child rather than
 * slotting onto it, so avatars and other composite components work here too.
 */
export function RadioGroupIcon({ className, children }: RadioGroupIconProps) {
  return (
    <span className={cn(css.icon, className)} aria-hidden>
      {children}
    </span>
  );
}
